import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { TOOLBAR_HEIGHT } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateEditorToolbar';
import {
  ComponentJsonLogicKey,
  ComponentJsonLogicRecord,
} from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/ComponentEditorSections/ComponentJsonLogicEditor/types';
import { SectionAccordion } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/ComponentEditorSections/SectionAccordion';
import { SCREEN_EDITOR_CONTROL_PANEL_ID } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenEditor/InquiryTemplateScreenEditor';
import MaximizableCodeEditor from 'dashboard/components/MaximizableCodeEditor';
import { FULL_SCREEN_HEADER_HEIGHT_XS } from 'dashboard/layouts/ShowViewLayoutV2';
import { titleCase } from 'dashboard/lib/utils/stringFormat';
import { Paragraph } from 'design-system/components/Text';

const StyledWrapper = styled.div`
  & + & {
    margin-top: ${Spacing[3]};
  }
`;

const StyledParagraph = styled(Paragraph)`
  margin-bottom: ${Spacing[1]};
`;

type ComponentJsonLogicCodeEditorProps = {
  jsonLogicFields: ComponentJsonLogicRecord;
  onJSONUpdate: (
    componentConfigUpdates: Partial<
      Record<ComponentJsonLogicKey, ComponentJsonLogicRecord[ComponentJsonLogicKey]>
    >,
  ) => void;
  editable: boolean;
};

const ComponentJsonLogicCodeEditor = ({
  jsonLogicFields,
  editable,
  onJSONUpdate,
}: ComponentJsonLogicCodeEditorProps) => {
  return (
    <SectionAccordion title='Component JSONLogic'>
      {(Object.keys(jsonLogicFields) as Array<ComponentJsonLogicKey>).map(
        (fieldName: ComponentJsonLogicKey) => {
          const fieldTitle = fieldName.endsWith('-server-evaluated')
            ? `${titleCase(fieldName.split('-server-evaluated')[0])} (evaluated on server)`
            : (titleCase(fieldName) as string);

          return (
            <StyledWrapper key={fieldName}>
              <StyledParagraph size='md'>{fieldTitle}</StyledParagraph>
              <MaximizableCodeEditor
                code={JSON.stringify(jsonLogicFields[fieldName], null, 2)}
                language='json'
                completionSources={{}}
                isReadOnly={!editable}
                offsetElementId={SCREEN_EDITOR_CONTROL_PANEL_ID}
                fullscreenTop={TOOLBAR_HEIGHT + FULL_SCREEN_HEADER_HEIGHT_XS}
                modalTitle={fieldTitle}
                onCodeUpdate={(updatedJsonLogic) => {
                  onJSONUpdate({
                    [fieldName]: updatedJsonLogic !== '' ? JSON.parse(updatedJsonLogic) : null,
                  });
                }}
              />
            </StyledWrapper>
          );
        },
      )}
    </SectionAccordion>
  );
};

export default ComponentJsonLogicCodeEditor;
